// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/frontend/stylesheets/font-awesome.min.css
// module id = 9
// module chunks = 0